import { Component, Input } from '@angular/core';

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent {
  @Input('control') control: any;
  @Input('fullWidth') fullWidth:boolean = false;
  @Input('readonly') readonly:boolean = false;
  @Input('disabled') disabled:boolean = false;
  @Input('size') size?:'small';
  @Input('name') name?:string;
  @Input('value') value:any;

  constructor() { }

}
